import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getDatabase } from 'firebase/database'
import { getMessaging, isSupported } from 'firebase/messaging'

const app = initializeApp({
  apiKey: 'AIzaSyDrkbP3XR6t-mKCwFdFqRAphuCBi-VQ5I8',
  authDomain: 'usatransfers-98899.firebaseapp.com',
  databaseURL: 'https://usatransfers-98899.firebaseio.com',
  projectId: 'usatransfers-98899',
  storageBucket: 'usatransfers-98899.appspot.com',
  messagingSenderId: '766046227744',
  appId: '1:766046227744:web:161fe232d6cede7d1bdb45'
})

//secondary
const sapp = initializeApp(
  {
    apiKey: 'AIzaSyAACthn48V0ydVSDr3laAZkRlfPt-TIceU',
    authDomain: 'clientapp-usatransfers.firebaseapp.com',
    databaseURL: 'https://clientapp-usatransfers.firebaseio.com',
    projectId: 'clientapp-usatransfers',
    storageBucket: 'clientapp-usatransfers.appspot.com',
    messagingSenderId: '430622643746'
  },
  'secondary'
)

//clients
const capp = initializeApp(
  {
    apiKey: 'AIzaSyASRAOjoC5uKKHPkEDBMSLjtVQbV39NbX8',
    authDomain: 'usatransfersclients.firebaseapp.com',
    databaseURL: 'https://usatransfersclients.firebaseio.com',
    projectId: 'usatransfersclients',
    storageBucket: 'usatransfersclients.appspot.com',
    messagingSenderId: '1070773253680',
    appId: '1:1070773253680:web:1163bdeafbaab621d75ff5',
    measurementId: 'G-VG6DZEXL0E'
  },
  'clients'
)

const auth = getAuth(capp)
// connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })

const database = getDatabase(app)

const sdatabase = getDatabase(sapp)

const cdatabase = getDatabase(capp)

const messaging = isSupported().then((res) => {
  if (res) {
    return getMessaging(app)
  }
  return null
})

export { auth, database, sdatabase, cdatabase, messaging }
